import { render, staticRenderFns } from "./rankTable.vue?vue&type=template&id=3f5711c7"
import script from "./rankTable.vue?vue&type=script&lang=js"
export * from "./rankTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports